import { HasPermission } from "#common/Funciones"
import { COLOR_PRIMARY_TEXT } from "#constants/Styles"
import { useApi } from "#hooks/useApi"
import VacationTable from "#vacation/components/VacationTable"
import { VacationProvider } from "#vacation/contexts/VacationContext"
import { vacationGet } from "#vacation/services/api"
import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Skeleton from "@mui/material/Skeleton"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import Grid2 from "@mui/material/Unstable_Grid2/Grid2"
import { useMemo, useState } from "react"

export default function VacationDetail({ colaborador }) {
	const params = useMemo(() => ({ colaborador }), [colaborador])
	const [reload, setReload] = useState(false)
	const { data, loading } = useApi(vacationGet, { autoFetch: true, params, reload })

	if (loading) return <VacationSkeleton />

	return (
		<Box
			sx={{
				background: COLOR_PRIMARY_TEXT,
				width: "100%",
				borderRadius: 5,
			}}
		>
			<Grid2
				container
				spacing={2}
				alignContent={"center"}
				alignItems={"flex-start"}
				justifyContent={"space-around"}
			>
				<Grid2 md={2} lg={4}>
					<Stack spacing={2} justifyItems={"flex-start"} alignItems={"center"}>
						<InfoTop data={data} />
						<div style={{ width: 200 }}>
							<Periods data={data?.periodos} />
						</div>
					</Stack>
				</Grid2>

				<Grid2 md={8} lg={7}>
					<VacationProvider reloadT={reload} setReloadT={setReload}>
						<VacationTable
							data={data}
							solicitudes={data?.solicitudes || []}
							colaborador={colaborador}
						/>
					</VacationProvider>
				</Grid2>
			</Grid2>
		</Box>
	)
}

/**
 * @type {Card}
 */
export const CardInfo = ({ contenido = null, ...props }) => {
	return (
		<Card
			sx={{
				minWidth: 100,
				height: "100%",
			}}
			{...props}
		>
			<CardContent
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					height: "100%",
				}}
			>
				{contenido}
			</CardContent>
		</Card>
	)
}

function InfoTop({ data }) {
	const is_rh = HasPermission("RH")
	let text = [
		{
			campo: "Dias Disponibles",
			contenido: data?.available_days,
		},
		{
			campo: "Dias Disfrutados",
			contenido: data?.taken_days,
		},
	]

	if (is_rh) {
		text.splice(1, 0, {
			campo: "Dias Proporcionales",
			contenido: data?.proportional_days,
		})
	}

	return (
		<div
			style={{
				display: "flex",
				flexGrow: 1,
				"flex-wrap": "wrap",
				// minWidth: "420px",
				justifyContent: "center",
			}}
		>
			{text.map(({ campo, contenido }, index) => (
				<CardInfo
					key={"info" + index}
					sx={{ minWidth: 200, margin: "5px" }}
					contenido={
						<Typography
							sx={{
								variant: "h7",
								whiteSpace: "pre-line",
								textAlign: "center",
							}}
						>
							<strong>{campo}</strong>
							{"\n" + contenido}
						</Typography>
					}
				/>
			))}
		</div>
	)
}

function Periods({ data }) {
	return (
		<Stack borderRadius={5} spacing={1} width={"100%"}>
			<CardInfo
				key={"periodos"}
				contenido={
					<Stack>
						<Typography variant="h6" sx={{ textAlign: "center" }}>
							Periodos
						</Typography>
						{!data?.count && (
							<Typography variant="h6" sx={{ textAlign: "center" }}>
								No hay periodos
							</Typography>
						)}

						{data?.data.map((periodo) => {
							const { date_start_year, date_end_year, days_remaining } =
								periodo
							return (
								<Typography key={periodo.id}>
									{`${date_start_year || " "} - ${
										date_end_year || " "
									} :  ${days_remaining} Dias`}
								</Typography>
							)
						})}
					</Stack>
				}
			/>
		</Stack>
	)
}

const VacationSkeleton = () => {
	return (
		<Grid2
			container
			spacing={2}
			padding={2}
			alignContent={"center"}
			justifyContent={"space-between"}
			alignItems={"center"}
		>
			<Grid2 xs={12}>
				<div>
					<Grid2 spacing={2} container justifyContent={"space-between"}>
						<Grid2 xs={4}>
							<Stack
								spacing={1}
								justifyItems={"center"}
								alignItems={"center"}
							>
								<Stack spacing={2} direction={"row"}>
									<Skeleton sx={{ minWidth: "180px", height: 60 }} />
									<Skeleton sx={{ minWidth: "180px" }} />
								</Stack>
								<div style={{ width: 200 }}>
									<Skeleton sx={{ minWidth: "10px", height: 80 }} />
									<Skeleton />
									<Skeleton />
									<Skeleton />
									<Skeleton />
									<Skeleton />
								</div>
							</Stack>
						</Grid2>
						<Grid2 xs={7}>
							<Skeleton sx={{ minWidth: "100px", height: 80 }} />
							<Skeleton />
							<Skeleton />
							<Skeleton />
							<Skeleton />
							<Skeleton />
						</Grid2>
					</Grid2>
				</div>
			</Grid2>
		</Grid2>
	)
}
